import { render, staticRenderFns } from "./signDraft.vue?vue&type=template&id=5470f85b&scoped=true&"
import script from "./signDraft.vue?vue&type=script&lang=js&"
export * from "./signDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470f85b",
  null
  
)

export default component.exports